import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
import { Language } from '../App';
interface NavbarProps {
  language: Language;
  setLanguage: (lang: Language) => void;
}
export function Navbar({
  language,
  setLanguage
}: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-espresso/80 backdrop-blur-lg shadow-lg' : 'bg-transparent'}`} data-id="element-130">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="flex items-center justify-between h-20" data-id="element-132">
          <div className="flex-1" data-id="element-133">
            <h1 className="text-pearl text-xl sm:text-2xl font-bold tracking-wider" data-id="element-134">
              PEARL ANN BROWN
            </h1>
          </div>

          <div className="flex-1 flex justify-center" data-id="element-135">
            <div className="flex items-center gap-2 bg-pearl/10 rounded-full px-4 py-2 border border-pearl/20" data-id="element-136">
              <button onClick={() => setLanguage('en')} className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${language === 'en' ? 'bg-pearl text-espresso' : 'text-pearl/60 hover:text-pearl'}`} data-id="element-137">
                EN
              </button>
              <span className="text-pearl/40" data-id="element-138">|</span>
              <button onClick={() => setLanguage('es')} className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${language === 'es' ? 'bg-pearl text-espresso' : 'text-pearl/60 hover:text-pearl'}`} data-id="element-139">
                ES
              </button>
            </div>
          </div>

          <div className="flex-1 flex justify-end" data-id="element-140">
            <a href="mailto:contact@pearlannbrown.com" className="text-pearl hover:text-pearl/80 transition-colors" data-id="element-141">
              <MailIcon className="w-6 h-6" data-id="element-142" />
            </a>
          </div>
        </div>
      </div>
    </motion.nav>;
}